<template>
  <div>
    <div class="mb-5">
      <h3>Demander un compte</h3>
      <h6>
        Vous devez être une ou un enseignant pour accéder à la plateforme
      </h6>
    </div>
    <UsersForm />
  </div>
</template>

<script>
/**
 * @file       Teacher register component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import UsersForm from "@/modules/admin/components/usersForm.vue";

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  components: { UsersForm }
};
</script>

<style lang="scss" scoped></style>
